import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_API_URL || '/'

axios.defaults.headers.common['Content-Type'] = 'application/form-data'

axios.interceptors.response.use(response => {
    return response
}, error => {
    // try to throw response of error, else throw error
    return Promise.reject(error.response || error)
})
